import { useMutation } from "@tanstack/react-query";
import axios from "axios";
import { __API_URL__ } from "../SERVER_URL";

const postUserActionLog = async (payload) => {
  const token = localStorage.getItem("token");

  if (!token) {
    console.warn("No token found. User may not be logged in.");
    return false;
  }

  await axios.post(`${__API_URL__}/api/appiell/user_actions_logs/`, payload, {
    headers: {
      Authorization: `Token ${token}`,
      "Content-Type": "application/json",
    },
  });

  return true;
};

const useUserActionsLogsMutation = () => {
  return useMutation({
    mutationFn: postUserActionLog,
  });
};

export default useUserActionsLogsMutation;
